import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=eabbbd64&scoped=true&"
import script from "./CategoryEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabbbd64",
  null
  
)

export default component.exports